import * as types from './mutation-types';

export const toggle = ({
  commit,
}, payload) => {
  commit(types.TOGGLE, payload);
};

export default {
  toggle,
};
